<template>
  <v-dialog
    :value="value"
    fullscreen
    persistent
    transition="dialog-bottom-transition"
    content-class="secao-detalhe-dialog"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-toolbar dense flat>
        <v-toolbar-title>
          Detalhe por seção - {{ titulo }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text class="secao-detalhe-content">
        <v-text-field
          :value="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
          class="mb-4 secao-detalhe-search"
          @input="$emit('update:search', $event)"
        ></v-text-field>
        <v-row
          dense
          align="stretch"
          class="secao-detalhe-body"
        >
          <v-col cols="12" md="4" class="d-flex secao-detalhe-ranking-col">
            <v-card outlined class="pa-3 secao-ranking-card">
              <div class="d-flex align-center justify-space-between mb-2">
                <h4 class="subtitle-1 font-weight-medium mb-0">
                  Ranking por assessor
                </h4>
                <span class="caption grey--text">
                  {{ total }} cadastros
                </span>
              </div>
              <v-data-table
                :headers="rankingHeaders"
                :items="ranking"
                :options.sync="rankingOptions"
                :height="tableHeight"
                dense
                fixed-header
                no-data-text="Sem assessores nesta seção."
                class="secao-ranking-data-table"
              >
                <template v-slot:item.percentual="{ item }">
                  {{ item.percentual.toFixed(1) }}%
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-col cols="12" md="8" class="d-flex flex-column secao-detalhe-table-col">
            <v-data-table
              :headers="detalheHeaders"
              :items="items"
              :search="search"
              :options.sync="detalheOptions"
              :height="tableHeight"
              class="elevation-1 secao-detalhe-table"
              fixed-header
              no-data-text="Sem registros para esta seção."
            >
              <template v-slot:item.created_at="{ item }">
                {{ formatDateTime(item.created_at) }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDateTime } from "../utils/formatters";

export default {
  name: "SecaoDetalheModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    titulo: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    ranking: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableHeight: "calc(80vh - 180px)",
      detalheHeaders: [
        { text: "ID", value: "idpessoa" },
        { text: "Nome Completo", value: "nome_completo" },
        { text: "Telefone", value: "telefone" },
        { text: "Email", value: "email" },
        { text: "Assessor", value: "assessor" },
        { text: "Zona", value: "zona" },
        { text: "Seção", value: "secao" },
        { text: "Data cadastro", value: "created_at" },
      ],
      rankingHeaders: [
        { text: "#", value: "posicao", align: "start", sortable: false },
        { text: "Assessor", value: "nome", align: "start" },
        { text: "Cadastros", value: "total", align: "end" },
        { text: "%", value: "percentual", align: "end" },
      ],
      detalheOptions: {
        sortBy: ["created_at"],
        sortDesc: [true],
        itemsPerPage: 25,
      },
      rankingOptions: {
        sortBy: ["posicao"],
        sortDesc: [false],
        itemsPerPage: 10,
      },
    };
  },
  methods: {
    formatDateTime,
  },
};
</script>

<style scoped>
.secao-detalhe-dialog ::v-deep .v-card {
  height: 100vh;
}

.secao-detalhe-dialog ::v-deep .v-card__text {
  height: calc(100vh - 96px);
  overflow: hidden;
}

.secao-detalhe-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.secao-detalhe-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  height: 100%;
}

.secao-detalhe-ranking-col {
  min-height: 0;
  overflow: hidden;
  max-width: 100%;
}

.secao-ranking-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

.secao-ranking-data-table {
  max-width: 100%;
  overflow-x: auto;
}

.secao-ranking-data-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto !important;
  max-height: calc(100% - 59px) !important;
  overflow-x: auto !important;
}

.secao-ranking-data-table.v-data-table--dense td,
.secao-ranking-data-table.v-data-table--dense th {
  padding: 0 8px !important;
}

.secao-ranking-data-table ::v-deep .v-data-footer {
  position: sticky !important;
  bottom: 0 !important;
  background-color: white !important;
  border-top: thin solid rgba(0, 0, 0, 0.12) !important;
}

.secao-detalhe-table-col {
  min-height: 0;
}

.secao-detalhe-table ::v-deep .v-data-table__wrapper {
  overflow-y: auto !important;
}
</style>
